// extracted by mini-css-extract-plugin
export default {"reCaptchaWrapper":"ReCaptcha_reCaptchaWrapper__SsXGt"};